import get from "lodash/get";
import { defaultArray } from "redux-store";

function tagsSelector(state) {
  return get(state, "pages.tags.data", defaultArray);
}

function tagsOptionsSelector(state) {
  return get(state, "pages.tags.options", defaultArray);
}

export { tagsSelector, tagsOptionsSelector };
